import React, { useEffect, useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import { getServicesToBeDelivered } from "../../../../../services/inventory/deliveryService";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import { Table } from "react-bootstrap";
import { InputAdornment } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../../partials/content/Illustration";
function DeliveryService() {
  const { values, setFieldValue } = useFormikContext();
  /*
  async function getServicesToBeDeliveredData() {
    const response = await getServicesToBeDelivered(values.salesOrderID);
    const { data } = response.data;
    const serviceOptionsTmp = [];
    for (const service of data.serviceItems) {
      serviceOptionsTmp.push({
        label: service.item.itemName,
        value: service,
      });
    }
    setServiceOptions(serviceOptionsTmp);
  }
  const [serviceOptions, setServiceOptions] = useState([]);
  useEffect(() => {
    getServicesToBeDeliveredData();
  }, []);
  */
  return (
    <React.Fragment>
      <FieldArray name="deliveryService">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.deliveryService &&
                    values.deliveryService.length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <th style={{ width: "50%" }}>Service Name</th>
                          <th style={{ width: "15%" }}>Quantity</th>
                          <th style={{ width: "15%" }}>Ordered Quantity</th>
                          <th style={{ width: "20%" }}>Unit</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.deliveryService &&
                      values.deliveryService.length > 0 ? (
                        values.deliveryService.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <FormOutlinedNoMarginTextField
                                value={`${item.serviceCode} ${item.serviceName}`}
                                InputProps={{
                                  startAdornment:
                                    item.itemType > 0 ? (
                                      <InputAdornment position="start">
                                        <BootstrapTooltip
                                          title={item.itemTypeName}
                                        >
                                          <i
                                            className={
                                              item.itemType === 1
                                                ? "fas fa-boxes text-success"
                                                : item.itemType === 2
                                                ? "fas fa-tools text-primary"
                                                : item.itemType === 3
                                                ? "fas fa-building text-info"
                                                : item.itemType === 4
                                                ? "fas fa-boxes text-warning"
                                                : item.itemType === 5
                                                ? "fas fa-boxes text-danger"
                                                : null
                                            }
                                          ></i>
                                        </BootstrapTooltip>
                                      </InputAdornment>
                                    ) : null,
                                  readOnly: true,
                                }}
                              />
                            </td>
                            <td>
                              <FormArrayTextField
                                arrayPropName="deliveryService"
                                index={index}
                                propName="qty"
                                quantityField
                                margin="none"
                              />
                            </td>
                            <td>
                              <FormArrayTextField
                                arrayPropName="deliveryService"
                                index={index}
                                propName="qtyOrder"
                                quantityField
                                margin="none"
                                readonly
                              />
                            </td>
                            <td>
                              <FormArrayTextField
                                arrayPropName="deliveryService"
                                index={index}
                                propName="uomName"
                                margin="none"
                                readonly
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center py-3" colSpan="4">
                            <Illustration
                              imageSource="INVIFO Sales.png"
                              description={`No available Service which ready to be delivered yet!`}
                              guidance="Hint: once the sales order has service items, it will be displayed here"
                              descriptionLeftIcon="fas fa-info-circle kt-font-warning"
                              size="md"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
    </React.Fragment>
  );
}

export default DeliveryService;
